<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Going Concerns</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onAuditGoingConcernCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateAuditGoingConcern()">
        <mat-icon>add</mat-icon>
        Add Going Concern
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="auditGoingConcerns()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditAuditGoingConcern($event)"
      (deleteClick)="onDeleteAuditGoingConcern($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
